import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import model1 from "../assets/images/model1.webp";
import model2 from "../assets/images/model2.webp";
import model3 from "../assets/images/model3.webp";


const HomeMainContainer = () => {
  const categories = [
    { label: "Men", status: "Available", img: model2, path: "/men" },
    { label: "Women", status: "Coming Soon", img: model1, path: "/women" },
    { label: "Kids", status: "Coming Soon", img: model3, path: "/kids" },
  ];

  return (
    <div className="min-h-screen text-gray-900">
      {/* HERO BANNER */}
      <section
        className="relative w-full h-[90vh] bg-cover"
        style={{
          backgroundImage:"url(/images/hereImg1.png)",
          backgroundPosition: "43% center",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/30"></div>

        {/* HERO CONTENT */}
        <div className="relative w-full max-w-7xl mx-auto px-6 md:px-12 h-full">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between h-full text-white">
            
            {/* LEFT — BRAND */}
            <motion.div
              initial={{ opacity: 0, x: -120 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.4 }}
              transition={{ duration: 0.9, ease: "easeOut" }}
              className="mt-24 md:mt-0"
            >
              <h1
                className="
                  font-serif tracking-widest
                  text-5xl sm:text-6xl md:text-7xl lg:text-8xl
                  mb-4
                  text-start md:-ml-12
                "
              >
                DAXMA
              </h1>
            </motion.div>

            {/* RIGHT — TAGLINE */}
            <motion.div
              initial={{ opacity: 0, x: 120 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.4 }}
              transition={{ duration: 0.9, ease: "easeOut", delay: 0.1 }}
              className="mt-4 md:mt-0 md:text-right max-w-md"
            >
              <p className="text-lg sm:text-xl md:text-6xl leading-tight">
                Let’s be a <span className="font-semibold">Trendsetter</span>
                <br />
                and Fashionstar
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      {/* SHOP BY CATEGORIES */}
      <section id="categories" className="px-4 sm:px-8 md:px-12 py-14">
        <h2 className="text-4xl font-serif text-center mb-10">
          <span className="text-cyan-600">Shop</span> By Categories
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6 place-items-center">
          {categories.map((cat, i) => (
            <Link to={cat.path} key={i} className="w-full flex justify-center">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.45, ease: "easeOut" }}
                whileHover={{
                  scale: 1.045,
                  transition: { duration: 0.2, ease: "easeOut" },
                }}
                className="
                  relative
                  w-[92%] sm:w-[300px] md:w-[340px] lg:w-[360px]
                  h-[420px] sm:h-[460px] md:h-[500px] lg:h-[520px]
                  rounded-3xl overflow-hidden shadow-lg
                "
              >
                <img
                  src={cat.img}
                  alt={cat.label}
                  className="w-full h-full object-cover"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />

                <div className="absolute bottom-6 text-center w-full text-white">
                  <p className="text-2xl sm:text-3xl font-semibold">
                    {cat.label}
                  </p>
                  <p className="text-sm opacity-90">{cat.status}</p>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HomeMainContainer;
